import React from 'react';
export const isIconFromPack = element => /*#__PURE__*/React.isValidElement(element) && Boolean(element.type.__iconPack);
export const getPackIconFromChildren = children => {
  if (!children) {
    return null;
  }
  let result = null;
  React.Children.map(children, child => {
    if (!result && isIconFromPack(child)) {
      result = child;
    }
  });
  return result;
};
export const convertIconPropsToPackIcon = props => {
  var _ref, _props$size;
  return {
    'data-testid': props['data-testid'],
    className: props.className,
    color: props.color,
    size: (_ref = (_props$size = props.size) != null ? _props$size : props.height) != null ? _ref : props.width
  };
};